@if (actionConfig) {
  <oaibox-stats-card [title]="actionConfig.name" [icon]="actionConfig.icon" [gradient]="actionConfig.gradientColor">
    <form [formGroup]="versionForm" (ngSubmit)="confirmAction()" class="form">
      <div>
        <input class="form-control" type="text" formControlName="version" placeholder="FlexRIC version">
        <p class="info"><i class="fa-solid fa-circle-info"></i> Before proceeding choose the upgrade version</p>
      </div>
    </form>
    <div class="modal-buttons-container p-g">
      <button class="btn btn-ignore" (click)="cancel()">Cancel</button>
      <button class="btn btn-{{actionConfig.gradientColor}}" (click)="confirmAction()">Proceed</button>
    </div>
  </oaibox-stats-card>
}
